/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * CIT
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BooleanApiResponse,
  ExamQueries,
  ExamQueriesApiResponse,
  ExamQueriesListResPagedDataApiResponse,
  GetAPIExamQueriesGetExamQueriesListParams,
  GetAPIExamQueriesGetExamQueryParams,
  UpdateExamQueryStatusReq
} from '../cit.schemas';

import { customAxios } from '../../../Utilities/customAxios';




export const postAPIExamQueriesSaveExamQuery = (
    examQueries: ExamQueries,
 signal?: AbortSignal
) => {
      
      
      return customAxios<ExamQueriesApiResponse>(
      {url: `/API/ExamQueries/SaveExamQuery`, method: 'POST',
      headers: {'Content-Type': 'application/json-patch+json', },
      data: examQueries, signal
    },
      );
    }
  


export const getPostAPIExamQueriesSaveExamQueryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAPIExamQueriesSaveExamQuery>>, TError,{data: ExamQueries}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAPIExamQueriesSaveExamQuery>>, TError,{data: ExamQueries}, TContext> => {
    
const mutationKey = ['postAPIExamQueriesSaveExamQuery'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAPIExamQueriesSaveExamQuery>>, {data: ExamQueries}> = (props) => {
          const {data} = props ?? {};

          return  postAPIExamQueriesSaveExamQuery(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAPIExamQueriesSaveExamQueryMutationResult = NonNullable<Awaited<ReturnType<typeof postAPIExamQueriesSaveExamQuery>>>
    export type PostAPIExamQueriesSaveExamQueryMutationBody = ExamQueries
    export type PostAPIExamQueriesSaveExamQueryMutationError = unknown

    export const usePostAPIExamQueriesSaveExamQuery = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAPIExamQueriesSaveExamQuery>>, TError,{data: ExamQueries}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAPIExamQueriesSaveExamQuery>>,
        TError,
        {data: ExamQueries},
        TContext
      > => {

      const mutationOptions = getPostAPIExamQueriesSaveExamQueryMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const getAPIExamQueriesGetExamQuery = (
    params?: GetAPIExamQueriesGetExamQueryParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<ExamQueriesApiResponse>(
      {url: `/API/ExamQueries/GetExamQuery`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetAPIExamQueriesGetExamQueryQueryKey = (params?: GetAPIExamQueriesGetExamQueryParams,) => {
    return [`/API/ExamQueries/GetExamQuery`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAPIExamQueriesGetExamQueryQueryOptions = <TData = Awaited<ReturnType<typeof getAPIExamQueriesGetExamQuery>>, TError = unknown>(params?: GetAPIExamQueriesGetExamQueryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIExamQueriesGetExamQuery>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAPIExamQueriesGetExamQueryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAPIExamQueriesGetExamQuery>>> = ({ signal }) => getAPIExamQueriesGetExamQuery(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAPIExamQueriesGetExamQuery>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAPIExamQueriesGetExamQueryQueryResult = NonNullable<Awaited<ReturnType<typeof getAPIExamQueriesGetExamQuery>>>
export type GetAPIExamQueriesGetExamQueryQueryError = unknown


export function useGetAPIExamQueriesGetExamQuery<TData = Awaited<ReturnType<typeof getAPIExamQueriesGetExamQuery>>, TError = unknown>(
 params: undefined |  GetAPIExamQueriesGetExamQueryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIExamQueriesGetExamQuery>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIExamQueriesGetExamQuery>>,
          TError,
          Awaited<ReturnType<typeof getAPIExamQueriesGetExamQuery>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIExamQueriesGetExamQuery<TData = Awaited<ReturnType<typeof getAPIExamQueriesGetExamQuery>>, TError = unknown>(
 params?: GetAPIExamQueriesGetExamQueryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIExamQueriesGetExamQuery>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIExamQueriesGetExamQuery>>,
          TError,
          Awaited<ReturnType<typeof getAPIExamQueriesGetExamQuery>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIExamQueriesGetExamQuery<TData = Awaited<ReturnType<typeof getAPIExamQueriesGetExamQuery>>, TError = unknown>(
 params?: GetAPIExamQueriesGetExamQueryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIExamQueriesGetExamQuery>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAPIExamQueriesGetExamQuery<TData = Awaited<ReturnType<typeof getAPIExamQueriesGetExamQuery>>, TError = unknown>(
 params?: GetAPIExamQueriesGetExamQueryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIExamQueriesGetExamQuery>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAPIExamQueriesGetExamQueryQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAPIExamQueriesGetExamQueriesList = (
    params?: GetAPIExamQueriesGetExamQueriesListParams,
 signal?: AbortSignal
) => {
      
      
      return customAxios<ExamQueriesListResPagedDataApiResponse>(
      {url: `/API/ExamQueries/GetExamQueriesList`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetAPIExamQueriesGetExamQueriesListQueryKey = (params?: GetAPIExamQueriesGetExamQueriesListParams,) => {
    return [`/API/ExamQueries/GetExamQueriesList`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAPIExamQueriesGetExamQueriesListQueryOptions = <TData = Awaited<ReturnType<typeof getAPIExamQueriesGetExamQueriesList>>, TError = unknown>(params?: GetAPIExamQueriesGetExamQueriesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIExamQueriesGetExamQueriesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAPIExamQueriesGetExamQueriesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAPIExamQueriesGetExamQueriesList>>> = ({ signal }) => getAPIExamQueriesGetExamQueriesList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAPIExamQueriesGetExamQueriesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAPIExamQueriesGetExamQueriesListQueryResult = NonNullable<Awaited<ReturnType<typeof getAPIExamQueriesGetExamQueriesList>>>
export type GetAPIExamQueriesGetExamQueriesListQueryError = unknown


export function useGetAPIExamQueriesGetExamQueriesList<TData = Awaited<ReturnType<typeof getAPIExamQueriesGetExamQueriesList>>, TError = unknown>(
 params: undefined |  GetAPIExamQueriesGetExamQueriesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIExamQueriesGetExamQueriesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIExamQueriesGetExamQueriesList>>,
          TError,
          Awaited<ReturnType<typeof getAPIExamQueriesGetExamQueriesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIExamQueriesGetExamQueriesList<TData = Awaited<ReturnType<typeof getAPIExamQueriesGetExamQueriesList>>, TError = unknown>(
 params?: GetAPIExamQueriesGetExamQueriesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIExamQueriesGetExamQueriesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAPIExamQueriesGetExamQueriesList>>,
          TError,
          Awaited<ReturnType<typeof getAPIExamQueriesGetExamQueriesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAPIExamQueriesGetExamQueriesList<TData = Awaited<ReturnType<typeof getAPIExamQueriesGetExamQueriesList>>, TError = unknown>(
 params?: GetAPIExamQueriesGetExamQueriesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIExamQueriesGetExamQueriesList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAPIExamQueriesGetExamQueriesList<TData = Awaited<ReturnType<typeof getAPIExamQueriesGetExamQueriesList>>, TError = unknown>(
 params?: GetAPIExamQueriesGetExamQueriesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAPIExamQueriesGetExamQueriesList>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAPIExamQueriesGetExamQueriesListQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const postAPIExamQueriesUpdateExamQueryStatus = (
    updateExamQueryStatusReq: UpdateExamQueryStatusReq,
 signal?: AbortSignal
) => {
      
      
      return customAxios<BooleanApiResponse>(
      {url: `/API/ExamQueries/UpdateExamQueryStatus`, method: 'POST',
      headers: {'Content-Type': 'application/json-patch+json', },
      data: updateExamQueryStatusReq, signal
    },
      );
    }
  


export const getPostAPIExamQueriesUpdateExamQueryStatusMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAPIExamQueriesUpdateExamQueryStatus>>, TError,{data: UpdateExamQueryStatusReq}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAPIExamQueriesUpdateExamQueryStatus>>, TError,{data: UpdateExamQueryStatusReq}, TContext> => {
    
const mutationKey = ['postAPIExamQueriesUpdateExamQueryStatus'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAPIExamQueriesUpdateExamQueryStatus>>, {data: UpdateExamQueryStatusReq}> = (props) => {
          const {data} = props ?? {};

          return  postAPIExamQueriesUpdateExamQueryStatus(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAPIExamQueriesUpdateExamQueryStatusMutationResult = NonNullable<Awaited<ReturnType<typeof postAPIExamQueriesUpdateExamQueryStatus>>>
    export type PostAPIExamQueriesUpdateExamQueryStatusMutationBody = UpdateExamQueryStatusReq
    export type PostAPIExamQueriesUpdateExamQueryStatusMutationError = unknown

    export const usePostAPIExamQueriesUpdateExamQueryStatus = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAPIExamQueriesUpdateExamQueryStatus>>, TError,{data: UpdateExamQueryStatusReq}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAPIExamQueriesUpdateExamQueryStatus>>,
        TError,
        {data: UpdateExamQueryStatusReq},
        TContext
      > => {

      const mutationOptions = getPostAPIExamQueriesUpdateExamQueryStatusMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    